import { render, staticRenderFns } from "./VuesticFileUploadContainer.vue?vue&type=template&id=14a7a2d6"
import script from "./VuesticFileUploadContainer.vue?vue&type=script&lang=js"
export * from "./VuesticFileUploadContainer.vue?vue&type=script&lang=js"
import style0 from "./VuesticFileUploadContainer.vue?vue&type=style&index=0&id=14a7a2d6&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pagsmile/front-end/pagsmile-dashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('14a7a2d6')) {
      api.createRecord('14a7a2d6', component.options)
    } else {
      api.reload('14a7a2d6', component.options)
    }
    module.hot.accept("./VuesticFileUploadContainer.vue?vue&type=template&id=14a7a2d6", function () {
      api.rerender('14a7a2d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vuestic-theme/vuestic-components/vuestic-file-upload-kyc/VuesticFileUploadContainer.vue"
export default component.exports